import * as React from 'react';
import { CardSection } from '@lightspeed/flame/Card';
import { Divider } from '@lightspeed/flame/Divider';
import { Option } from './Option';
import { OPTIONS } from './types';

interface OptionsProps {
  options: OPTIONS[];
}

const Options: React.FC<OptionsProps> = ({ options }) => {
  return (
    <>
      {options.map((option, index) => (
        <React.Fragment key={(option as OPTIONS) as string}>
          <CardSection large>
            <Option option={option} />
          </CardSection>
          {index !== options.length - 1 ? <Divider /> : null}
        </React.Fragment>
      ))}
    </>
  );
};
export default Options;
